import { AnimatePresence, motion } from "motion/react";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

/** Thin gold progress bar shown while the router resolves a navigation. */
export function TransitionLoader() {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Show progress bar briefly on navigation change
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-x-0 top-0 z-[100] h-0.5 overflow-hidden"
        >
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: "0%" }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="h-full w-full bg-secondary"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
